<template>
  <div class="manual-wrap">
    <header class="man-header">
      <div class="inner-box">
        <h1>
          <a href="#n" @click="goMain($event)">
            <img src="../../assets/img/img_logo.png" alt="">
            <span>통계표 이용 매뉴얼</span>
          </a>
        </h1>
        <button type="button" class="manual-print" @click="print()">통계표 이용 매뉴얼 인쇄</button>
      </div>
    </header>
    <main class="manual-container">
      <div class="inner-box">
        <aside class="manual-lnb">
          <ul>
            <li>
              <a href="#manual1_1" class="dep1-link manual1">통계표 선택</a>
              <ul>
                <li><a href="#manual1_1" class="on">① 통계 목록 조회</a></li>
                <li><a href="#manual1_2">② 통계 목록 및 통계표명 검색</a></li>
                <li><a href="#manual1_3">③ 조사별 부가정보 열람</a></li>
              </ul>
            </li>
            <li>
              <a href="#manual2_1" class="dep1-link manual2">통계표 활용</a>
              <ul>
                <li><a href="#manual2_1">① 통계표 화면구성</a></li>
                <li><a href="#manual2_2">② 통계표 차트 구성</a></li>
                <li><a href="#manual2_3">③ 조회설정(필터)</a></li>
                <li><a href="#manual2_4">④ 피벗(Pivoting)</a></li>
              </ul>
            </li>
            <li>
              <a href="#manual3_1" class="dep1-link manual3">부가 기능 활용</a>
              <ul>
                <li><a href="#manual3_1">① 통계표 기본정보 보기</a></li>
                <li><a href="#manual3_2">② 행열전환 및 정렬</a></li>
                <li><a href="#manual3_3">③ 화면복사 및 다운로드</a></li>
                <li><a href="#manual3_4">④ Open API</a></li>
                <li><a href="#manual3_5">⑤ 링크주소(URL) 생성</a></li>
              </ul>
            </li>
          </ul>
        </aside>
        <article class="manual-cont">
          <div class="manual-section" id="manual1_1">
            <h2>통계표 선택</h2>
            <div class="manual-info-txt manu1">
              <ul>
                <li>문화셈터는 ‘분야별 상세통계’ 메뉴를 통해 총 6개 분야(문화, 예술, 문화산업, 관광, 스포츠, 종합)로 나누어 다양한 통계를 제공합니다.</li>
                <li>통계표는 논리적 성격에 따라 구분되어있으며 순차적으로 통계표를 조회/검색할 수 있습니다.</li>
              </ul>
            </div>
            <div class="sub-section">
              <h3><span>1</span> 통계표 목록 조회</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual1_1.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    홈페이지 상단의 메뉴 이동영역을 통해 문화셈터가 제공하는 ‘분야별 상세 통계’ 메뉴에 접근합니다.
                    <ul>
                      <li>- 문화셈터는 문화, 예술, 문화산업, 관광, 스포츠, 종합 총 6개의 분야로 통계를 제공합니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    각 유형별 통계 조사명을 선택할 수 있습니다.
                  </li>
                  <li>
                    <span class="num">3</span>
                    각 조사별로 구성된 통계 표 경로에 따라 통계표를 순차적으로 조회할 수 있습니다.
                  </li>
                  <li>
                    <span class="num">4</span>
                    통계표를 열람하던 중 다른 통계표를 추가로 조회하고 싶을 때 활용할 수 있습니다.
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual1_2">
              <h3><span>2</span> 통계 목록 및 통계표명 검색</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual1_2.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    검색 기능 제공 : 키워드 검색, 명칭(초성)검색, 세부 조건 검색
                  </li>
                  <li>
                    <span class="num">2</span>
                    상세검색 제공
                    <ul>
                      <li>- 통계표 : 통계표명 중 포함된 단어 검색 (여러 단어 검색 가능)</li>
                      <li>- 항목명 : 항목이 포함된 단어 검색(여러 단어 검색 가능)</li>
                      <li>- 입력 년도 : 통계표 입력 연도 검색(다중 선택 가능)</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual1_3">
              <h3><span>3</span> 조사별 부가정보 열람</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual1_3.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    조사별로 제공되는 부가 정보 열람 : 통계보고서, MDSS(마이크로데이터), 메타정보(조사 개요 정보)
                  </li>
                  <li>
                    <span class="num">2</span>
                    통계보고서 : 선택된 조사와 관련된 통계보고서(바로보기, 다운로드 가능)
                  </li>
                  <li>
                    <span class="num">3</span>
                    MDSS : 선택된 조사와 관련된 마이크로데이터(도출된 통계 조사 원본)
                  </li>
                  <li>
                    <span class="num">4</span>
                    메타정보 : 선택된 조사와 관련된 메타 정보
                    <ul>
                      <li>- 통계명, 통계종류, 법적근거, 조사목적, 조사주기, 조사대상, 조사방법, 조사기간, 조사내용, 작성체계, 이용시 유의점 등</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="manual-section" id="manual2_1">
            <h2>통계표 활용</h2>
            <div class="manual-info-txt manu2">
              <ul>
                <li>여러 개의 통계표를 탭(Tab)으로 구분하여 열람할 수 있습니다.</li>
                <li>통계표 내 원하는 구성 항목을 설정하거나 피벗을 활용하여 표두, 표측의 항목을 설정하여 열람할 수 있습니다.</li>
                <li>통계표에 대한 다양한 차트를 통해 정보를 시각화하여 추이를 열람할 수 있습니다.</li>
              </ul>
            </div>
            <div class="sub-section">
              <h3><span>1</span> 통계표 화면구성</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual2_1.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    여러 개의 통계표를 탭(Tab) 형태로 구분하여 화면의 이동 없이 열람할 수 있습니다.
                    <ul>
                      <li>- 통계표(tab)의 제공은 하나의 조사에서 다른 조사의 통계표로 넘어가면 초기화 됩니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    통계표의 주요 정보와 부가 기능을 활용할 수 있는 버튼 목록
                    <ul>
                      <li>- 기본정보, 행열전환, 피벗, 조회설정, 화면복사, 다운로드, Open API, 링크주소(URL)생성, 주석, 도움말</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">3</span>
                    통계표와 해당 통계표의 차트 제공 기능
                  </li>
                  <li>
                    <span class="num">4</span>
                    통계표 내 표두, 표측의 색상과 폰트 사이즈 탬플릿을 설정하여 한 화면에서 많은 자료를 열람할 수 있습니다.
                  </li>
                  <li>
                    <span class="num">5</span>
                    통계표 내에서는 통계표명 표시, 표두 중심의 정렬 기능, 특정 값 선택 시 해당되는 표두/표측의 색상 표시 기능을 제공합니다.
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual2_2">
              <h3><span>2</span> 통계표 차트 구성</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual2_2.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    차트 제공 개요 : 통계표의 차트는 두 가지 방식으로 제공됩니다.
                    <ul>
                      <li>- 통계표 내 특정 값을 선택 또는 드래그하면 해당되는 값을 기준으로 통계표 하단에서 막대그래프를 제공합니다.</li>
                      <li>- 기본적으로 제공하는 통계표의 표측 항목을 중심으로 다양한 차트를 제공합니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    통계표 내 특정 값을 선택하거나 드래그하면 해당 표두/표측의 항목을 중심으로 막대 그래프를 자동생성 합니다.
                    <ul>
                      <li>- 기본정보, 행열전환, 피벗, 조회설정, 화면복사, 다운로드, Open API, 링크주소(URL)생성, 주석, 도움말</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">3</span>
                    생성된 차트를 이미지로 다운로드 받을 수 있습니다.
                  </li>
                </ul>
                <div class="manual-img mgt"><img src="../../assets/img/img_manual2_3.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    기본적으로 제공하는 통계표의 표측 항목을 중심으로 다양한 유형의 차트를 제공합니다.
                    <ul>
                      <li>- 통계표의 구성 항목 중 표측의 대분류 값을 중심으로 챠트를 제공합니다.</li>
                      <li>- 표측 대분류 내 하위 값을 중심으로 다중 막대 그래프를 기본으로 제공합니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    통계 내 필터 기능을 제공합니다.
                    <ul>
                      <li>- 통계표 내 총합이 제공되는 경우 차트가 왜곡될 수 있기 때문에 ‘전체(또는 표본 수, 사례 수) 값을 제외하고 차트보기’ 기능 제공</li>
                      <li>- 시계열(보통 연도) 기반의 차트 조회, 표측 대분류 내 하위 분류값 선택 후 차트 생성 기능 제공</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">3</span>
                    약 9개의 차트 템플릿을 제공합니다.(다중막대, 추이, 누적 추이 등)
                  </li>
                  <li>
                    <span class="num">4</span>
                    차트 내에서 특정 내역에 마우스를 올리면 표두/표측 정보와 실제 수치를 말풍선으로 제공합니다.
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual2_3">
              <h3><span>3</span> 조회설정(필터)</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual2_4.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    ‘조회설정’ 버튼을 클릭하면 통계표의 오른쪽에서 왼쪽으로 조회설정(필터) 기능이 도출됩니다.
                    <ul>
                      <li>- 조회설정(필터) 기능은 통계표를 구성하는 다양한 항목 중 원하는 것을 선택해서 볼 수 있도록 하는 기능입니다.</li>
                      <li>- 또한, 필터 설정 후 특정 값 선택과 드래그를 통해 하단의 차트로 통계표를 시각화할 수 있습니다.</li>
                      <li>- 조회설정(필터) 기능의 최 상단에서는 키워드를 통해 항목의 정보를 조회할 수 있습니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    조사/입력된 시점을 기준으로 통계표를 조회할 수 있습니다.(다중선택 가능)
                  </li>
                  <li>
                    <span class="num">3</span>
                    표두의 항목 중 원하는 것을 선택하여 통계표를 조회할 수 있습니다.(다중선택 가능)
                  </li>
                  <li>
                    <span class="num">4</span>
                    쵸측의 항목 중 원하는 것을 선택하여 통계표를 조회할 수 있습니다. (다중선택 가능)
                  </li>
                  <li>
                    <span class="num">5</span>
                    ‘적용’ 버튼 클릭 시 설정된 조회조건에 따라 통계표를 제공합니다.
                  </li>
                  <li>
                    <span class="num">6</span>
                    조회설정된 값을 모두 초기화합니다.
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual2_4">
              <h3><span>4</span> 피벗(Pivoting)</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual2_5.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    ‘피벗’ 버튼을 클릭하면 통계표의 오른쪽에서 왼쪽으로  피벗(Pivoting) 기능이 도출됩니다.
                    <ul>
                      <li>- 피벗(필터) 기능은 사용자가 원하는 데이터의 위치를 표두나 표측으로 이동하여 조회할 수 있는 기능입니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    피벗(Pivoting) 사용 방법
                    <ul>
                      <li>- 최초에는 기본 통계표의 표측과 표두의 항목들이 셋팅되어있습니다.</li>
                      <li>- 축 바꾸기(Pivoting)하고자 하는 항목을 선택하면 , 선택한 정보에 색상(회색)이 표시됩니다.</li>
                      <li>- 선택한 정보는 추가 해제 버튼을 클릭 후 화살표로 이동하거나 마우스로 드래그하여 표두나 표측으로 이동합니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">3</span>
                    ‘실행’ 버튼 클릭 시 설정된 피벗정보에 따라 통계표가 제공됩니다.
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="manual-section" id="manual3_1">
            <h2>부가 기능 활용</h2>
            <div class="manual-info-txt manu3">
              <ul>
                <li>
                  문화셈터의 통계를 보다 쉽게 활용하거나 공유할 수 있도록 다양한 부가기능을 제공하고 있습니다.
                  <div>- 통계표 기본정보 보기,  행열전환, 화면복사, 다운로드, Open API, 링크주소(URL) 생성, 주석 등</div>
                </li>
                <li>다양한 통계 부가기능을 업무에 활용하세요.</li>
              </ul>
            </div>
            <div class="sub-section">
              <h3><span>1</span> 통계표 기본정보 보기</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual3_1.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    ‘기본정보’ 버튼을 클릭하면 통계표의 기본정보 안내 팝업이 호출됩니다.
                    <ul>
                      <li>- 통계표(tab)의 제공은 하나의 조사에서 다른 조사의 통계표로 넘어가면 초기화 됩니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    제공되는 기본정보
                    <ul>
                      <li>- 통계표명, 통계표의 경로(순차적 위치), 조사명, 통계표가 입력된 연도</li>
                      <li>- URL : 문화셈터의 각 통계표는 별도의 URL을 제공하며 해당 주소를 복사하여 아웃링크 등으로 서비스할 수 있습니다.</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual3_2">
              <h3><span>2</span> 행열전환 및 정렬</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual3_2.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    ‘행열전환’ 버튼을 클릭하면 현재 제공되고 있는 통계표의 표두/표측의 항목이 전환됩니다.
                  </li>
                  <li>
                    <span class="num">2</span>
                    표두의 항목을 크릭하면 정렬 기능이 활성화되며 화살표를 통해 오름차순, 내림차순으로 정렬할 수 있습니다.
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual3_3">
              <h3><span>3</span> 화면복사 및 다운로드</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual3_3.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    ‘화면복사’ 버튼을 클릭하면 ‘클립보드에 저장되었습니다.’ 라는 메시지와 함게 통계표의 모든 항목과 값이 복사됩니다.
                    <ul>
                      <li>- 복사된 정보를 엑셀이나 메모장, BI 툴 등에 옮겨 붙여 활용할 수 있습니다.</li>
                    </ul>
                  </li>
                  <li>
                    <span class="num">2</span>
                    ‘다운로드’ 버튼을 클릭하면 다운로드 설정 팝업이 호출됩니다. (Excel / CSV / TXT 파일 형태를 선택하여 다운로드)
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual3_4">
              <h3><span>4</span> Open API</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual3_4.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    ‘Open API’ 버튼을 클릭하면 제공 설정 팝업이 호출됩니다.
                  </li>
                  <li>
                    <span class="num">2</span>
                    ‘Open API’는 기본 JSON으로 제공되며, 사용시 ‘소속’과 ‘사용목적’을 입력합니다.
                  </li>
                  <li>
                    <span class="num">3</span>
                    ‘URL 생성’ 버튼 클릭 시 해당 통계표에 대한 JSON 파일 주소가 생성됩니다.
                  </li>
                  <li>
                    <span class="num">4</span>
                    생성된 URL을 복사할 수 있으며 JSON 파일 해석을 위해 홈페이지의 Open API 매뉴얼을 참조할 수 있습니다.
                  </li>
                  <li>
                    <span class="num">5</span>
                    해당 주소를 통해 통계표의 항목과 값을 JSON으로 제공받을 수 있습니다.
                  </li>
                </ul>
              </div>
            </div>
            <div class="sub-section" id="manual3_5">
              <h3><span>5</span> 링크주소(URL) 생성</h3>
              <div class="box-indent">
                <div class="manual-img"><img src="../../assets/img/img_manual3_5.jpg" alt=""></div>
                <ul class="num-list">
                  <li>
                    <span class="num">1</span>
                    ‘링크주소(URL) 생성’ 버튼을 클릭하면 제공 설정 팝업이 호출됩니다.
                  </li>
                  <li>
                    <span class="num">2</span>
                    ‘링크주소(URL) 생성’ 기능 설명
                    <ul>
                      <li>- 현재 해당 통계표에 적용하신(조회설정, 피벗 등) 내역을 다음 방문 때 조회 설정 없이 이용하실 수 있도록 URL을 배포하는 기능</li>
                      <li>- 문화셈터의 통계를 자주 활용하시는 고객은 생성되는 URL을 즐겨찾기 하신 후 활용하시는 것을 추천드립니다.</li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </article>
      </div>
    </main>
  </div>
</template>

<script>
import $ from 'jquery'
export default {
  name: 'StatsManual',
  mounted() {
		$(".manual-lnb a").on('click', function (event) {
      if (this.hash !== "") {
        event.preventDefault();
        const hash = this.hash;
        $('.manual-lnb a').removeClass('on')

        if($(this).hasClass('dep1-link')) {
          $(this).next().find('>li:first-child>a').addClass('on')
        } else {
          $(this).addClass('on')
        }
        
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function () {
          //window.location.hash = hash;
        });
      }
    })
	},
  methods: {    
    print() {
      window.print()
    },

    goMain (evt) {
			this.$router.push({ name: '메인화면' })
      evt.preventDefault();
		},
  }
}
</script>

<style scoped>
@media print {
  body {
    print-color-adjust: exact;
    -webkit-print-color-adjust: exact;
  }

  .man-header, .manual-lnb {
    display: none;
  }

  .manual-container .inner-box{
    display: block;
    width: 1000px;
  }
}
</style>
  